import {z} from 'zod';

// Facebook Credentials Response Schema (GET response)
export const FacebookCredentialsResponseSchema = z.object({
  username: z.string().nullable(),
  enabled: z.boolean(),
});

// Facebook Credentials Request Schema (PATCH body)
export const FacebookCredentialsRequestSchema = z.object({
  username: z.string().nullable().optional(),
  password: z.string().nullable().optional(),
  enabled: z.boolean().nullable().optional(),
});

export type FacebookCredentialsResponse = z.infer<typeof FacebookCredentialsResponseSchema>;
export type FacebookCredentialsRequest = z.infer<typeof FacebookCredentialsRequestSchema>;

// API Arg Schemas
export const GetFacebookCredentialsApiArgSchema = z.object({});
export const PatchFacebookCredentialsApiArgSchema = z.object({
  facebookCredentialsRequestBody: FacebookCredentialsRequestSchema,
});

export type GetFacebookCredentialsApiArg = z.infer<typeof GetFacebookCredentialsApiArgSchema>;
export type PatchFacebookCredentialsApiArg = z.infer<typeof PatchFacebookCredentialsApiArgSchema>;

export type GetFacebookCredentialsApiResponse = FacebookCredentialsResponse;
export type PatchFacebookCredentialsApiResponse = void;

// Meta Authorization Response Schema (GET response)
export const MetaAuthorizationResponseSchema = z.object({
  enabled: z.boolean().nullable(),
  authorized: z.boolean().nullable(),
});

// Facebook Login URL Response Schema (GET response)
export const FacebookLoginUrlResponseSchema = z.object({
  url: z.string().nullable(),
});

export type MetaAuthorizationResponse = z.infer<typeof MetaAuthorizationResponseSchema>;
export type FacebookLoginUrlResponse = z.infer<typeof FacebookLoginUrlResponseSchema>;

// API Arg Schemas for new endpoints
export const GetMetaAuthorizationApiArgSchema = z.object({});
export const GenerateFacebookLoginUrlApiArgSchema = z.object({});

export type GetMetaAuthorizationApiArg = z.infer<typeof GetMetaAuthorizationApiArgSchema>;
export type GenerateFacebookLoginUrlApiArg = z.infer<typeof GenerateFacebookLoginUrlApiArgSchema>;

export type GetMetaAuthorizationApiResponse = MetaAuthorizationResponse;
export type GenerateFacebookLoginUrlApiResponse = FacebookLoginUrlResponse;

// Facebook Callback Response Schema (POST response)
export const FacebookCallbackResponseSchema = z.object({
  username: z.string().nullable(),
  enabled: z.string().nullable(),
  errorMessage: z.string().nullable(),
});

// Facebook Callback Request Schema (POST params)
export const FacebookCallbackRequestSchema = z.object({
  code: z.string().nullable(),
  state: z.string().nullable(),
  error: z.string().nullable(),
});

export type FacebookCallbackResponse = z.infer<typeof FacebookCallbackResponseSchema>;
export type FacebookCallbackRequest = z.infer<typeof FacebookCallbackRequestSchema>;

// API Arg Schema for callback
export const PostFacebookCallbackApiArgSchema = z.object({
  code: z.string().nullable(),
  state: z.string().nullable(),
  error: z.string().nullable(),
});

export type PostFacebookCallbackApiArg = z.infer<typeof PostFacebookCallbackApiArgSchema>;
export type PostFacebookCallbackApiResponse = FacebookCallbackResponse;

// Delete Facebook Authorization API Arg Schema
export const DeleteFacebookAuthorizationApiArgSchema = z.object({});

export type DeleteFacebookAuthorizationApiArg = z.infer<
  typeof DeleteFacebookAuthorizationApiArgSchema
>;
export type DeleteFacebookAuthorizationApiResponse = void;

export const PatchFacebookAuthorizationRequestSchema = z.object({
  enable: z.boolean().nullable().optional(),
});

export const PatchFacebookAuthorizationResponseSchema = z.object({
  enabled: z.boolean().nullable(),
});

export type PatchFacebookAuthorizationResponse = z.infer<
  typeof PatchFacebookAuthorizationResponseSchema
>;

export const PatchFacebookAuthorizationApiArgSchema = z.object({
  patchFacebookAuthorizationRequestBody: PatchFacebookAuthorizationRequestSchema,
});

export type PatchFacebookAuthorizationApiArg = z.infer<
  typeof PatchFacebookAuthorizationApiArgSchema
>;
export type PatchFacebookAuthorizationApiResponse = PatchFacebookAuthorizationResponse;
